/*
 * CacheCleanupPlugin
 * 在 H5 关闭/刷新（beforeunload/unload）时自动清理 cacheFileTool 管理的缓存（含 blob: URL）。
 * 使用：app.use(CacheCleanupPlugin, { events: ['beforeunload','unload'], log: true })
 * 可选：如配置 'pagehide'，进入 bfcache (event.persisted === true) 会跳过清理。
 */
import cacheFileTool from '@/utils/cacheFileTool'

const CacheCleanupPlugin = {
  install(app, options = {}) {
    const defaultOptions = { events: ['beforeunload', 'unload'], log: false }
    const cfg = { ...defaultOptions, ...options }

    // 防止热更新或多次调用导致重复绑定
    if (globalThis.__CACHE_CLEANUP_PLUGIN_INSTALLED__) {
      return
    }
    globalThis.__CACHE_CLEANUP_PLUGIN_INSTALLED__ = true

    const cleanup = (evt) => {
      // 如配置了 'pagehide' 且进入 bfcache (evt.persisted === true)，跳过清理，避免返回时资源不可用
      if (evt?.type === 'pagehide' && evt.persisted) {
        if (cfg.log) {
          console.info('[CacheCleanupPlugin] skip cleanup due to bfcache')
        }
        return
      }
      try {
        const removed = cacheFileTool.removeAllCacheFiles()
        if (cfg.log) {
          console.info(`[CacheCleanupPlugin] cleaned ${removed} cached file(s).`)
        }
      } catch (e) {
        console.info('[CacheCleanupPlugin] cleanup error', e)
      }
    }

    // 绑定事件：默认在 beforeunload/unload 清理；如配置 pagehide，进入 bfcache 时跳过清理
    cfg.events.forEach((evt) => {
      try {
        // webview可能不可靠
        // window.addEventListener(evt, (e) => cleanup(e), { passive: true })
      } catch (_) {
        // do nothing
      }
    })

    // 暴露手动触发入口，便于在页面/路由离开时调用
    app.config.globalProperties.$cacheCleanup = cleanup
  }
}

export default CacheCleanupPlugin